import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { BillingPeriod } from "features/subscription";

type Props = {
  value: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
};

export const UserPlanBillingToggle = ({ value, onChange }: Props) => {
  const play = usePlaySound();

  const handleChange = (period: BillingPeriod) => () => {
    if (value === period) return;
    play();
    onChange(period);
  };

  return (
    <div className="flex-row-el items-center w-full max-w-sm rounded-full border-2 border-solid border-outline bg-white p-1 shadow-[0_2px_0_rgba(63,74,97,0.12),0_3px_8px_rgba(63,74,97,0.08)]">
      <button
        type="button"
        onClick={handleChange("monthly")}
        className={`type-inherit-font flex-row-el flex-1 items-center justify-center rounded-full border-0 px-4 py-2 transition-transform active:translate-y-1 cursor-pointer ${
          value === "monthly" ? "bg-[#70b1f4] text-white" : "bg-transparent text-textcolor-black/70"
        }`}
      >
        <span className="type-text type-sm leading-tight whitespace-nowrap">
          {I18n.t("MSG_SUBSCRIPTION_MONTHLY_LABEL")}
        </span>
      </button>
      <button
        type="button"
        onClick={handleChange("annual")}
        className={`type-inherit-font flex-row-el flex-1 items-center justify-center rounded-full border-0 px-4 py-2 transition-transform active:translate-y-1 cursor-pointer ${
          value === "annual" ? "bg-[#70b1f4] text-white" : "bg-transparent text-textcolor-black/70"
        }`}
      >
        <span className="type-text type-sm leading-tight whitespace-nowrap">
          {I18n.t("MSG_SUBSCRIPTION_ANNUAL_LABEL")}
        </span>
      </button>
    </div>
  );
};
